import React, { useState, useEffect } from "react";
import { FaPaperclip } from "react-icons/fa";
import "./ChatUI.css";
import { useSocket } from "config/SocketContext";
import { API_SEND_MESSAGE_CHAT } from "api/chat";
import { GET_CONVERSATION } from "api/chat";
import { API_LIST_CONVERSATION_CHAT } from "api/chat";
import { API_LIST_STORE } from "api/store-managemnt";
import { useLocation, useNavigate } from "react-router-dom";
import { Skeleton } from "antd";

const Chat = () => {
  const { connect, disconnect, isOnline, socket } = useSocket();

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState({});
  const [activeUser, setActiveUser] = useState("Store");
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [search, setSearch] = useState("");

  const [conversationLoading, setConversationLoading] = useState();
  const [conversationListLoading, setConversationListLoading] = useState();

  const location = useLocation();

  // Extract query param from URL
  const searchParams = new URLSearchParams(location.search);
  const chatId = searchParams.get("chatId");
  const fetchListing = async () => {
    try {
      setConversationListLoading(true);
      const res = await API_LIST_STORE({
        // page: pagination.current,
        limit: 10,
        name: search,
      });
      if (res) {
        // setLoading(false);
        console.log(res?.conversations, "responslajdfhlajkdfdsjk");
        setConversations(res?.providers);
        setConversationListLoading(false);
      }
    } catch (err) {
      setConversationListLoading(false);
    }
  };

  const handleSend = async () => {
    if (message?.trim() === "") return;

    const newMessage = {
      sender: "laundry",
      receiver: activeUser,
      text: message,
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    setMessages((prevMessages) => ({
      ...prevMessages,
      [newMessage.receiver]: [
        ...(prevMessages[newMessage.receiver] || []),
        newMessage,
      ],
    }));
    socket.emit("send-message", newMessage);
    setMessage("");

    //--------------------- new mesages ----------------
    const payLoad = {
      message: message,
      conversation_id: selectedConversation ? selectedConversation : chatId,
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
    try {
      const res = await API_SEND_MESSAGE_CHAT(payLoad);
      if (res) {
        fetchListing();
        console.log("dsad");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleClick = (user) => {
    // setActiveUser(user);

    // Get the current URL parameters
    setSelectedConversation(user?._id);
    handleGetConversation(user?._id);
    const currentParams = new URLSearchParams(window.location.search);

    // Set the new `chatId` query param
    currentParams.set("chatId", user?._id);

    // Update the URL without reloading the page
    const newUrl = `${window.location.pathname}?${currentParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
  };
  const renderMessages = (user) => {
    return (messages[user] || []).map((msg, index) => (
      <div
        key={index}
        className={`chat-message ${
          msg.sender === "laundry" ? "sent" : "received"
        }`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: msg.sender === "laundry" ? "flex-start" : "flex-end",
        }}
      >
        {conversationLoading ? (
          <>
            <Skeleton active />
          </>
        ) : (
          <div
            className="chat-message-container flex items-start"
            style={{
              maxWidth: "60%",
              // wordBreak: "break-word",
              flexDirection: msg.sender === "laundry" ? "row" : "row-reverse",
            }}
          >
            <img
              src={`https://i.pravatar.cc/150?img=${
                msg.sender === "laundry" ? "3" : "12"
              }`} // Replace with actual profile picture URLs
              alt="Profile"
              className="chat-message-profile"
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                margin: "0 10px",
              }}
            />
            <div
              className="chat-message-content"
              style={{
                backgroundColor:
                  msg.sender === "laundry" ? "#0084FF" : "#e0e0e0",
                color: msg.sender === "laundry" ? "#fff" : "#000",
                padding: "10px 15px",
                maxWidth: "100%",
                borderRadius:
                  msg.sender === "laundry"
                    ? "0px 20px 20px 23px" // Curved more on the left (laundry)
                    : "20px 0px 20px 23px", // Curved more on the right (Store)
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)", // Optional for some depth
              }}
            >
              <div className="chat-message-text">{msg.text}</div>
              <div
                className="chat-message-time text-right text-[0.8rem] text-[white]"
                style={msg.sender === "laundry" ? { color: "white" } : {}}
              >
                {msg.time}
              </div>
            </div>
          </div>
        )}
      </div>
    ));
  };

  // const userList = Object.keys(messages).map((user, index) => (
  //   <div
  //     key={index}
  //     className={`chat-list-item ${user === activeUser ? "active" : ""}`}
  //     onClick={() => setActiveUser(user)}
  //   >
  //     <div>{user}</div>
  //     <div className="chat-list-item-preview">
  //       {messages[user]?.slice(-1)[0]?.text
  //         ? messages[user]?.slice(-1)[0]?.text.length > 20
  //           ? `${messages[user]?.slice(-1)[0]?.text.slice(0, 20)}...`
  //           : messages[user]?.slice(-1)[0]?.text
  //         : ""}
  //     </div>
  //     <div className="chat-list-item-time">
  //       {messages[user]?.slice(-1)[0]?.time || ""}
  //     </div>
  //   </div>
  // ));

  const userList = conversations?.map((user, index) => (
    <>
      {conversationListLoading ? (
        <Skeleton active />
      ) : (
        <div
          key={index}
          className={`chat-list-item ${
            user?._id == (selectedConversation ? selectedConversation : chatId)
              ? "actives"
              : ""
          }`}
          onClick={() => handleClick(user)}
          // className={`chat-list-item ${user === activeUser ? "active" : ""}`}
          // onClick={() => setActiveUser(user)}
        >
          <div>{user?.store_name}</div>
          <div className="chat-list-item-preview">
            {messages[user]?.slice(-1)[0]?.text
              ? messages[user]?.slice(-1)[0]?.text.length > 20
                ? `${messages[user]?.slice(-1)[0]?.text.slice(0, 20)}...`
                : messages[user]?.slice(-1)[0]?.text
              : ""}
          </div>
          <div className="chat-list-item-time">
            {messages[user]?.slice(-1)[0]?.time || ""}
          </div>
        </div>
      )}
    </>
  ));

  const handleGetConversation = async (id) => {
    try {
      setConversationLoading(true);
      // setSelectedConversation(chatId);
      const res = await GET_CONVERSATION({
        id,
      });
      // setMessages(res.messages);
      if (res) {
        setConversationLoading(false);

        console.log(res?.conversations, "responslajdfhlajkdfdsjk");

        // setConversations(res?.providers);
      }
    } catch (err) {
      setConversationLoading(false);
    }
  };

  useEffect(() => {
    fetchListing();
  }, [search]);
  useEffect(() => {
    if (socket) {
      socket.on("message", (data) => {
        console.log(
          selectedConversation,
          data.message.conversation_id,
          "dfljasdhlfkjsdhafka"
        );
        setMessages((prevMessages) => [...prevMessages, data?.message]);
        console.log("sasasasa", data);

        // If the message belongs to the current conversation, update the last message in the table
        if (data?.message?.conversation_id == data?.conversation?._id) {
          console.log("hello from indide");
        }
      });
      return () => {
        socket.off("message");
      };
    }
  }, [socket]);

  useEffect(() => {
    // Set some dummy messages from the other side (Store)
    setMessages({
      Store: [
        {
          sender: "Store",
          text: "Hello! How can I assist you today?",
          time: "10:15 AM",
        },
      ],
    });
  }, []);

  useEffect(() => {
    if (socket == null) return;

    socket.on("receive-message", (message) => {
      setMessages((prevMessages) => ({
        ...prevMessages,
        [message.sender]: [...(prevMessages[message.sender] || []), message],
      }));
    });

    return () => socket.off("receive-message");
  }, [socket]);

  useEffect(() => {
    handleGetConversation(chatId);
  }, [chatId]);

  console.log("messages", messages);
  return (
    <div className="chat-container">
      <div className="chat-sidebar">
        <h2>Chats</h2>
        <input
          type="text"
          placeholder="Enter Keywords"
          className="chat-search"
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="chat-list">
          {userList.length > 0 ? userList : <div>No chats available</div>}
        </div>
      </div>
      <div className="chat-main">
        <div className="chat-header">
          <div className="chat-header-title">{activeUser}</div>
          {/* <div className="chat-header-status flex items-center">
            <span
              className={`status-badge ${
                isOnline ? "bg-green-500" : "bg-gray-500"
              } mr-2 inline-block h-2.5 w-2.5 rounded-full`}
            ></span>
            <span className={`text-${isOnline ? "green" : "gray"}-600`}>
              {isOnline ? "Online" : "Offline"}
            </span>
          </div> */}
        </div>
        <div className="chat-messages">{renderMessages(activeUser)}</div>

        <div className="chat-inputss flex items-center space-x-2 rounded-lg border bg-white p-4  dark:bg-gray-800">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a Message"
            className="flex-1 resize-none rounded-lg border bg-gray-100 p-2 text-gray-800 outline-none focus:ring-2 focus:ring-brand-500 dark:bg-gray-700 dark:text-gray-200 dark:focus:ring-brand-400"
          ></textarea>
          <button
            onClick={handleSend}
            className="flex items-center justify-center rounded-lg bg-brand-500 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-300"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default Chat;
